import React, { useState } from 'react';
import './StepsToFollow.scss';
import { useTranslation } from 'react-i18next';

const StepsToFollow = () => {
    const [currentStep] = useState(2);
    const { t } = useTranslation()

    const steps = [
        {
            number: 1,
            documents: [
                { id: '1.1', name: 'Document 1.1', type: 'pdf', active: true },
                { id: '1.2', name: 'Document 1.2', type: 'pdf', active: true }
            ]
        },
        {
            number: 2,
            documents: [
                { id: '2.1', name: 'Document 2.1', type: 'pdf', active: true },
                { id: '2.2', name: 'Document 2.2', type: 'csv', active: true },
                { id: '2.3', name: 'Document 2.3', type: 'pdf', active: false }
            ]
        },
        {
            number: 3,
            documents: [
                { id: '3.1', name: 'Document 3.1', type: 'png', active: false }
            ]
        }
    ];

    const getIconClass = (type: string) => {
        switch (type) {
            case 'pdf':
                return 'bi bi-filetype-pdf';
            case 'csv':
                return 'bi bi-filetype-csv';
            case 'png':
                return 'bi bi-filetype-png';
            default:
                return 'bi bi-file';
        }
    };

    return (
        <div id="steps-container" className="text-center rounded-1 p-3">
            <span className="mt-2 h4">{t('Steps')}</span>
            <div className="row g-2 mt-2">
                {steps.map((step) => (
                    <div key={step.number} className="col-md-4 col-sm-12 d-flex flex-column align-items-center">
                        <div className={`step-circle ${step.number <= currentStep ? 'active' : 'inactive'}`}>
                            {step.number}
                        </div>
                        <div className="mt-5 mb-3 w-100">
                            {step.documents.map((doc) => (
                                <div key={doc.id} className={`document-card p-3 mb-3 ${doc.active ? (step.number <= currentStep ? 'active' : 'inactive') : 'inactive'}`}>
                                    <i className={`me-2 document-icon ${doc.type} ${getIconClass(doc.type)} ${!doc.active ? 'inactive-text' : ''}`}> </i>
                                    <span className={`document-name ${!doc.active ? 'inactive-text' : ''}`}>{doc.name}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                ))}
            </div>
        </div>
    );
};

export default StepsToFollow;